import script from "./CustomCakeInquiryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomCakeInquiryModal.vue?vue&type=script&setup=true&lang=js"

import "./CustomCakeInquiryModal.vue?vue&type=style&index=0&id=40a892ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40a892ea"]])

export default __exports__